<template>
  <div>
    <a-modal
        :visible="show"
        cancelText="Zamknij"
        okText="Dodaj urządzenia"
        title="Dodaj wiele urządzeń"
        @ok="addDevices"
        :maskClosable="false"
        :closable="false"
        @cancel="close">

      <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" layout="horizontal">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="Adresy MAC">
              <a-textarea v-model="form.macAddressesInput" placeholder="Adresy MAC" :rows="6"/>
            </a-form-item>
            <a-form-item label="Lokalizacja">
              <a-select v-model="selectedDorm">
                <a-select-option v-for="dorm in dorms" :value="dorm.code" :key="dorm.code">{{ dorm.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <a-modal
        :visible="addingModal.visible"
        :maskClosable="false"
        :closable="false"
        :keyboard="false"
    >
      <template slot="footer">
        <a-button type="primary" @click="closeAddingModal" :disabled="!addingModal.finished">
          Zamknij
        </a-button>
      </template>
      <a-progress :percent="addingModal.progressPercent"/>
      <a-list :data-source="macAddresses" item-layout="horizontal" size="small" style="margin-top: 1em">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta>
            <div slot="title">
              <a-badge :status="item.status" style="margin-left: 8px"/>
              <span style="font-weight: 500">{{ item.macAddress }}</span>
              <span v-if="item.error" style="margin-left: 5px; font-weight: 400">- {{ item.error }}</span>
            </div>
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </a-modal>
  </div>
</template>

<script>

import httpClient from "@/utils/httpClient";

function sleep(milliseconds) {
  const date = Date.now();
  let currentDate = null;
  do {
    currentDate = Date.now();
  } while (currentDate - date < milliseconds);
}

export default {
  name: "BulkAddModal",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingDorms: false,
      dorms: [],
      selectedDorm: null,
      addingModal: {
        visible: false,
        progressPercent: 0,
        finished: false
      },
      macAddresses: [],
      form: {
        macAddressesInput: '',
      },
    }
  },
  mounted() {
    this.loadDorms()
  },
  methods: {
    addDevices() {
      this.addingModal.visible = true
      this.macAddresses = this.form.macAddressesInput.split('\n').filter((mac) => {
        return mac !== '';
      }).map((mac) => {
        return {
          macAddress: mac.trim(),
          status: 'processing',
          error: null
        };
      });

      this.$nextTick(() => {
        this.processListOfDevices().then(() => {
          this.addingModal.finished = true
        })
      })
    },

    async processListOfDevices() {
      let size = this.macAddresses.length;
      let progress = 0;
      for (let i = 0; i < size; i++) {
        await httpClient.post("/admin/devices", {
          macAddress: this.macAddresses[i].macAddress,
          accountUuid: this.$route.params.uuid,
          dormCode: this.selectedDorm
        }).then(() => {
          this.macAddresses[i].status = 'success'
        }).catch((error) => {
          console.log("Failed: ", error.response)
          this.macAddresses[i].status = 'error'
          this.macAddresses[i].error = this.parseError(error.response.data.message)
        }).finally(() => {
          progress++
        })

        this.addingModal.progressPercent = Math.round(progress / size * 100)
        await sleep(100)
      }
    },

    parseError(message) {
      if (message.startsWith("Device already exists")) {
        return "Urządzenie już istnieje"
      } else if (message.startsWith("Invalid MAC address")) {
        return "Zły format adresu MAC"
      } else {
        return message
      }
    },

    loadDorms() {
      this.loadingDorms = true
      httpClient
          .get(`/admin/dorms`)
          .then((response) => {
            this.dorms = response;
            if (this.dorms && this.dorms.length > 0) {
              this.selectedDorm = this.dorms[0].code
            }
          }).catch((error) => {
            if (error.response.status !== 401) {
              this.$message.error("Wystąpił błąd z pobraniem listy lokalizacji!")
            }
      }).finally(() => {
        this.loadingDorms = false
      })
    },

    closeAddingModal() {
      this.addingModal.visible = false
      this.addingModal.progressPercent = 0
      this.addingModal.finished = false
    },

    close() {
      this.macAddresses = []
      this.form.macAddressesInput = ''
      this.$emit('close')
    }
  }
}
</script>
